export default "<app-alert></app-alert>\n<router-outlet></router-outlet>\n"